export enum TabSessionStorageDispatchTypes {
  SET_TAB_DATA_INVOKE = "SET_TAB_DATA_INVOKE",
  SET_TAB_DATA_SUCCESS = "SET_TAB_DATA_SUCCESS",
}
